import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { GenericService } from '../../generic.service';
import { language } from '../../../assets/data/languageData';
import { LandingService } from '../../landing-page/service/landing.service';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterModule],
    templateUrl: './summary.component.html',
    styleUrl: './summary.component.scss'
})
export class FeedbackSummaryComponent implements OnInit {
  deviceData: any = {};
  language: string = '';
  languageData: any;
  deviceData$: any = null;
  languageIndex: number = 0;

  constructor(
    private router: Router,
    private genericService: GenericService,
    private landingService: LandingService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    if (this.deviceData?.languageSelected)
      this.language = this.deviceData?.languageSelected;
    else this.language = 'English';
    this.languageIndex = this.language === 'English' ? 0 : 1;
    this.languageChange(null, this.language);
  }

  get languageOptions() {
    return this.landingService.getLanguageOptions();
  }

  navigate(pageName: any) {
    this.deviceData['languageSelected'] = this.language;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    if (pageName == 'training') {
      this.router.navigate(['/training']);
    }

    if (pageName == 'feedbackSummary') {
      this.router.navigate(['/feedbackSummary']);
    }
  }

  languageChange($event: any, languageSelected: string) {
    if (languageSelected) this.language = languageSelected;
    else this.language = $event?.target?.value;
    if (this.language === 'Spanish')
      this.languageData = language.spanish.feedBackSummary;
    else this.languageData = language.english.feedBackSummary;
    this.languageIndex = this.language === 'English' ? 0 : 1;
  }

  navigateToLadingPage() {
    this.deviceData['languageSelected'] = this.language;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigate(['/']);
  }
}
